define('app/views/gender_selector_view',['app/setup'], function(takhfifan) {

  takhfifan.GenderSelectorView = Backbone.View.extend({

    events: {
      'click li' : 'update',
      'click a' : 'preventDefault'
    },

    initialize: function() {
      var _this = this;
    },

    setView: function(gender) {
      $option = this.$('option:contains("' + gender + '")').first();
      this.$('span.value').first().html($option.html());
      $option.prop('selected', true);
    },

    update: function(event) {
      event.preventDefault();
      var gender = $(event.target).text();
      var gender_value = $(event.target).data('value');

      this.setView(gender);
      if (this.model != undefined) {
        this.model.set('gender', gender_value);
      }
    },

    preventDefault: function(event) {
      event.preventDefault();
    }

  });

  $('.tkh-genders').each(function(){
    new takhfifan.GenderSelectorView({ el: $(this) });
  });

});

